import advertisersManifest from 'store/domains/getuniq/advertisers.manifest'
import partnersManifest from 'store/domains/getuniq/partners.manifest'
import recommendationsManifest from 'store/domains/getuniq/recommendations.manifest'
import marketplaceToolsManifest from 'store/domains/getuniq/marketplaceTools.manifest'
import servicesManifest from 'store/domains/common/services.manifest'
import financeManifest from 'store/domains/common/finance.manifest'
import {
  servicesEntries as accountTransferServicesEntries,
  financeEntries as accountTransferFinanceEntries,
} from 'store/domains/getuniq/accountTransfer.manifest'
import { servicesEntries as leadManagerServicesEntries } from 'store/domains/getuniq/leadManager.manifest'
import { commonDomains } from './common'

export default {
  recommendations: {
    manifest: recommendationsManifest,
    i18nNamespaces: ['recommendations', 'audits', 'benchmarks'],
  },
  advertisers: {
    manifest: advertisersManifest,
    i18nNamespaces: ['advertisers', 'services'],
  },
  partners: {
    manifest: partnersManifest,
    i18nNamespaces: ['partners_program', 'reward_calculator'],
  },
  marketplaceTools: {
    manifest: marketplaceToolsManifest,
    i18nNamespaces: ['marketplace_tools', 'billing', 'auth', 'countries', 'payment_profiles'],
  },
  services: {
    manifest: [
      ...servicesManifest,
      ...accountTransferServicesEntries,
      ...leadManagerServicesEntries,
    ],
    i18nNamespaces: [
      ...commonDomains.services.i18nNamespaces,
      'account_transfer',
      'lead_manager',
    ],
  },
  finance: {
    manifest: [...financeManifest, ...accountTransferFinanceEntries],
    i18nNamespaces: [...commonDomains.finance.i18nNamespaces, 'account_transfer'],
  },
}
